import(/* webpackMode: "eager" */ "/app/apps/consumer/app/(public)/help/faq/[id]/page.tsx");
